import { statusAPI } from '../../api';
const state = () => ({
    requestId: null,
    status: [],
});

const mutations = {
    setRequestId(state, requestId) {
        state.requestId = requestId;
    },
    setRequestStatus(state, status) {
        state.status = status;
    },
    clearStatusState(state) {
        state.requestId = null;
        state.status = [];
    },
};

const actions = {
    async getStatusOfRequest({ commit }, requestId) {
        const status = await statusAPI.getStatusByRequestIdAPI(requestId);
        commit('setRequestId', requestId);
        commit('setRequestStatus', status.data);
        return status.data;
    },
};

export default {
    state,
    mutations,
    actions,
};
